import { sameIdsIn } from 'utils/array'

const GET_TASKS_UNASSIGNED_PARTICIPANTS =
  'dofe-bo/unassignedParticipantsTasks/GET_TASKS_UNASSIGNED_PARTICIPANTS'
const GET_TASKS_UNASSIGNED_PARTICIPANTS_SUCCESS =
  'dofe-bo/unassignedParticipantsTasks/GET_TASKS_UNASSIGNED_PARTICIPANTS_SUCCESS'
const GET_TASKS_UNASSIGNED_PARTICIPANTS_FAIL =
  'dofe-bo/unassignedParticipantsTasks/GET_TASKS_UNASSIGNED_PARTICIPANTS_FAIL'
const SET_TASKS_UNASSIGNED_PARTICIPANTS_SELECTED =
  'dofe-bo/unassignedParticipantsTasks/SET_TASKS_UNASSIGNED_PARTICIPANTS_SELECTED'
const TOGGLE_TASKS_UNASSIGNED_PARTICIPANTS_ALL_SELECTED =
  'dofe-bo/unassignedParticipantsTasks/TOGGLE_TASKS_UNASSIGNED_PARTICIPANTS_ALL_SELECTED'
const SET_FILTER = 'dofe-bo/unassignedParticipantsTasks/SET_FILTER'
const SET_BASE_FILTER = 'dofe-bo/unassignedParticipantsTasks/SET_BASE_FILTER'
const SET_PARAMS = 'dofe-bo/unassignedParticipantsTasks/SET_PARAMS'
const SET_DISABLED_CACHE =
  'dofe-bo/unassignedParticipantsTasks/SET_DISABLED_CACHE'
const REMOVE_DETAIL_DATA =
  'dofe-bo/unassignedParticipantsTasks/REMOVE_DETAIL_DATA'

const BULK_ASSIGN_AWARD_LEADER_RESET =
  'dofe-bo/unassignedParticipantsTasks/BULK_ASSIGN_AWARD_LEADER_RESET'
const BULK_ASSIGN_AWARD_LEADER =
  'dofe-bo/unassignedParticipantsTasks/BULK_ASSIGN_AWARD_LEADER'
const BULK_ASSIGN_AWARD_LEADER_SUCCESS =
  'dofe-bo/unassignedParticipantsTasks/BULK_ASSIGN_AWARD_LEADER_SUCCESS'
const BULK_ASSIGN_AWARD_LEADER_FAIL =
  'dofe-bo/unassignedParticipantsTasks/BULK_ASSIGN_AWARD_LEADER_FAIL'

const initialState = {
  list: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  count: null,
  filter: '',
  loading: false,
  loaded: false,
  selectedIds: [],
  bulkAssign: {
    loading: false,
    loaded: false
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TASKS_UNASSIGNED_PARTICIPANTS:
      return {
        ...state,
        loading: true
      }
    case GET_TASKS_UNASSIGNED_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: action.headers['x-total-count'],
        pages:
          Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
      }
    case GET_TASKS_UNASSIGNED_PARTICIPANTS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case SET_TASKS_UNASSIGNED_PARTICIPANTS_SELECTED:
      return {
        ...state,
        selectedIds: action.selectedIds
      }
    case TOGGLE_TASKS_UNASSIGNED_PARTICIPANTS_ALL_SELECTED:
      if (sameIdsIn(action.selectedIds, action.selectableIds)) {
        return {
          ...state,
          selectedIds: []
        }
      }

      return {
        ...state,
        selectedIds: [...action.selectableIds]
      }
    case SET_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy
      })
    case SET_BASE_FILTER:
      return Object.assign({}, state, {
        baseFilter: action.filterBy
      })
    case SET_PARAMS:
      return {
        ...state,
        limit:
          action.options.limit !== undefined
            ? action.options.limit
            : state.limit,
        offset:
          action.options.offset !== undefined
            ? action.options.offset
            : state.offset,
        filter:
          action.options.filter !== undefined
            ? action.options.filter
            : state.filter,
        sort:
          action.options.sort !== undefined ? action.options.sort : state.sort
      }
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    case BULK_ASSIGN_AWARD_LEADER_RESET:
      return {
        ...state,
        bulkAssign: {
          loading: false,
          loaded: false
        }
      }
    case BULK_ASSIGN_AWARD_LEADER:
      return {
        ...state,
        bulkAssign: {
          ...state.bulkAssign,
          loading: true,
          loaded: false
        }
      }
    case BULK_ASSIGN_AWARD_LEADER_SUCCESS:
      return {
        ...state,
        bulkAssign: {
          ...state.bulkAssign,
          loading: false,
          loaded: true,
          detail: action.result
        }
      }
    case BULK_ASSIGN_AWARD_LEADER_FAIL:
      return {
        ...state,
        bulkAssign: {
          ...state.bulkAssign,
          loading: false,
          error: action.error
        }
      }
    default:
      return state
  }
}

export function getTasksUnassignedParticipants({
  filter = null,
  limit,
  offset,
  sort
}) {
  const query = filter ? `&filter=${filter}` : ''
  const firstRow = (offset && `&firstRow=${offset}`) || ''
  const maxRows = (limit && `&maxRows=${limit}`) || ''
  const getTotalRowCount = '&getTotalRowCount=true'
  const sortQuery = (sort && `&sort=${sort}`) || ''

  return {
    types: [
      GET_TASKS_UNASSIGNED_PARTICIPANTS,
      GET_TASKS_UNASSIGNED_PARTICIPANTS_SUCCESS,
      GET_TASKS_UNASSIGNED_PARTICIPANTS_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/participants-unassigned?with=ORGANIZATION,PARTICIPANT_PERSON,AWARD${query}${maxRows}${firstRow}${getTotalRowCount}${sortQuery}`
      )
  }
}

export function setTasksUnassignedParticipantsSelected(selectedIds) {
  return {
    type: SET_TASKS_UNASSIGNED_PARTICIPANTS_SELECTED,
    selectedIds
  }
}

export function toggleTasksUnassignedParticipantsAllSelected(selectedIds, selectableIds) {
  return {
    type: TOGGLE_TASKS_UNASSIGNED_PARTICIPANTS_ALL_SELECTED,
    selectedIds,
    selectableIds
  }
}

export function setFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setBaseFilter(filterBy) {
  return {
    type: SET_BASE_FILTER,
    filterBy
  }
}

export function setUnassignedParticipantsParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function removeDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function removeCache() {
  return {
    type: SET_DISABLED_CACHE
  }
}

export function bulkAssignAwardLeaderReset() {
  return {
    type: BULK_ASSIGN_AWARD_LEADER_RESET
  }
}

export function bulkAssignAwardLeader({ awardIds, awardLeaderId }) {
  return {
    types: [
      BULK_ASSIGN_AWARD_LEADER,
      BULK_ASSIGN_AWARD_LEADER_SUCCESS,
      BULK_ASSIGN_AWARD_LEADER_FAIL
    ],
    promise: client =>
      client.post(
        'api/awards/assignment-leaders/bulk',
        {
          data: {
            awardIds,
            leaderId: awardLeaderId
          }
        }
      )
  }
}
